import { Smartphone, Tablet, Monitor, Share2, Plus, Download } from "lucide-react";

const STEPS_IOS = [
  { num: "1", text: "Open wealthfirstinc.tv in Safari on your iPhone or iPad." },
  { num: "2", text: "Tap the Share icon at the bottom of the screen.", icon: Share2 },
  { num: "3", text: "Scroll down and select 'Add to Home Screen'.", icon: Plus },
  { num: "4", text: "Confirm — the Wealth First Inc. icon will appear on your home screen." },
];

const STEPS_ANDROID = [
  { num: "1", text: "Open wealthfirstinc.tv in Chrome on Android." },
  { num: "2", text: "Tap the three-dot menu in the top right." },
  { num: "3", text: "Select 'Install app' or 'Add to Home screen'.", icon: Download },
  { num: "4", text: "Confirm — Wealth First Inc. launches like a native app." },
];

const STEPS_DESKTOP = [
  { num: "1", text: "Visit wealthfirstinc.tv in Chrome, Edge, or Brave." },
  { num: "2", text: "Click the install icon (⊕) in the address bar.", icon: Download },
  { num: "3", text: "Confirm to install — the app opens in its own window, no tabs, no clutter." },
];

function StepList({ steps, testId }) {
  return (
    <ol className="space-y-5" data-testid={testId}>
      {steps.map((s) => (
        <li key={s.num} className="flex gap-5 items-start">
          <span className="font-display text-3xl shrink-0" style={{ color: "var(--brass)", lineHeight: 1 }}>{s.num}</span>
          <p className="text-sm leading-relaxed pt-1" style={{ color: "var(--ink)" }}>{s.text}</p>
        </li>
      ))}
    </ol>
  );
}

export default function InstallApp() {
  return (
    <div data-testid="install-page" className="max-w-[1200px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-16 reveal text-center max-w-3xl mx-auto">
        <p className="eyebrow mb-4">Install the App</p>
        <h1 className="font-display text-6xl md:text-7xl mb-6 leading-[0.95]">
          Wealth First Inc., <br /> on your <em style={{ color: "var(--brass)" }}>home screen</em>.
        </h1>
        <p className="text-lg leading-relaxed" style={{ color: "var(--ink-muted)" }}>
          A progressive web app — no app store required. Install in under thirty seconds, on any device.
          Watch interviews, read editorial, and check your funding portal as if it were native.
        </p>
      </div>

      <hr className="hairline mb-16" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="p-10" style={{ border: "1px solid var(--hairline)" }}>
          <Smartphone size={28} style={{ color: "var(--brass)" }} className="mb-5" />
          <p className="eyebrow mb-3">iOS</p>
          <h3 className="font-display text-3xl mb-6">iPhone & iPad</h3>
          <StepList steps={STEPS_IOS} testId="steps-ios" />
        </div>
        <div className="p-10" style={{ border: "1px solid var(--brass)", background: "var(--surface)" }}>
          <Tablet size={28} style={{ color: "var(--brass)" }} className="mb-5" />
          <p className="eyebrow mb-3">Android</p>
          <h3 className="font-display text-3xl mb-6">Phone & Tablet</h3>
          <StepList steps={STEPS_ANDROID} testId="steps-android" />
        </div>
        <div className="p-10" style={{ border: "1px solid var(--hairline)" }}>
          <Monitor size={28} style={{ color: "var(--brass)" }} className="mb-5" />
          <p className="eyebrow mb-3">Desktop</p>
          <h3 className="font-display text-3xl mb-6">Mac, Windows, Linux</h3>
          <StepList steps={STEPS_DESKTOP} testId="steps-desktop" />
        </div>
      </div>

      <p className="text-center mt-16 text-xs uppercase tracking-[0.2em]" style={{ color: "var(--ink-faint)" }}>
        Works offline · Push notifications · No app-store gatekeeping
      </p>
    </div>
  );
}
